import React from "react";
import { Box, TablePagination } from "@mui/material";
import BondTable from "../BondTable";

const SecMasterTable = ({
  secMasterData,
  selectedColumns,
  page,
  itemsPerPage,
  totalElements,
  onPageChange,
  onRowsPerPageChange,
  onCusipClick,
  onSort,
  sortConfig,
}) => {
  return (
    <>
      <Box
        sx={{
          padding: "0px",
          height: "calc(100vh - 225px)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <BondTable
          source="sec-master"
          selectedColumns={selectedColumns}
          filteredData={secMasterData}
          handleBuyClick={() => {}}
          handleCusipClick={onCusipClick}
          sectionKey="sec-master"
          onSort={onSort}
          sortConfig={sortConfig}
        />
      </Box>

      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          color: "white",
          zIndex: 1000,
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
        }}
      >
        <TablePagination
          component="footer"
          sx={{ ".MuiSelect-select": { p: "4px 24px 5px 8px !important" } }}
          showFirstButton
          showLastButton
          rowsPerPage={itemsPerPage}
          rowsPerPageOptions={[20, 50, 100]}
          page={page}
          onRowsPerPageChange={onRowsPerPageChange}
          onPageChange={onPageChange}
          count={totalElements}
          labelDisplayedRows={({ from, to, count }) => `${from.toLocaleString()}–${to.toLocaleString()} of ${count.toLocaleString()}`}
        />
      </Box>
    </>
  );
};

export default SecMasterTable;
